<template>
  <section>
    <section
      :data-background-video="videoUrl"
      :data-background-image="gifUrl"
      data-background-video-loop="true"
      data-background-opacity="0.4"
      id="stockSlide"
    >
      <div class="sl-block" data-block-type="text">
        <div
          class="sl-block-content"
          data-placeholder-tag="h2"
          data-placeholder-text="Title Text"
          style="text-align: left; z-index: 10; margin-bottom: 50px"
          dir="ui"
        >
          <h2 style="text-align: center">Stock Quotes</h2>
        </div>
      </div>

      <div
        class="sl-block"
        data-block-type="table"
        style="min-width: 120px; width: 100%; left: 29px; top: 175.5px"
      >
        <table>
          <tr>
            <th>Ticker</th>
            <!--
            <th>Open</th>
            -->
            <th>Price</th>
            <th>Change</th>
            <th>Change %</th>
          </tr>

          <tbody :key="refresher">
            <tr v-for="(item, ticker) in stocks" :key="ticker">
              <td>{{ ticker }}</td>
              <!--
              <td style="text-align: right">{{ stocks[ticker].open }}</td>
              -->
              <td style="text-align: right">{{ stocks[ticker].price }}</td>
              <td style="text-align: right">{{ stocks[ticker].change }}</td>
              <td style="text-align: right">
                {{ stocks[ticker].changePercent }}%
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "",
  props: ["value"],
  components: {},
  beforeMount() {
    if (navigator.userAgent.indexOf("Silk") > 0) {
      this.gifUrl = "/img/presentationbackgrounds/stocks2.gif";
    } else {
      this.videoUrl = "/img/presentationbackgrounds/stocks2.mp4";
    }

    let s = this.value.toUpperCase().split(",");
    for (let i = 0; i < s.length; i++) {
      this.stocks[s[i].trim()] = {
        symbol: null,
        price: 0,
        change: 0,
        open: 0,
        changePercent: 0,
        updated: false,
      };
    }
    this.timer = setInterval(this.refresh, 300000);
    this.refresh();
  },
  mounted() {},
  beforeDestroy() {
    clearInterval(this.timer);
  },
  data() {
    return {
      gifUrl: null,
      videoUrl: null,
      isLoading: false,
      stocks: {},
      refresher: 0,
      timer: null,
    };
  },

  computed: {
    ...mapGetters(["getUser"]),
  },
  watch: {},
  methods: {
    refresh() {
      let me = this;

      let s = this.value.toUpperCase().split(",");
      for (let i = 0; i < s.length; i++) {
        fetch(
          `https://cloud.iexapis.com/stable/stock/${s[
            i
          ].toUpperCase()}/quote?token=pk_2b7ed7ac956843fb91fc61cb39b3d204`
        )
          .then((response) => response.json())
          .then(function (data) {
            me.stocks[data.symbol] = {
              symbol: data.symbol,
              price: data.latestPrice,
              open: data.open,
              change: data.change,
              changePercent: (data.changePercent * 100).toFixed(2),
              updated: true,
            };
            me.refresher++;
            console.log(me.stocks);
          });
      }
    },
  },
};
</script>
<style>
#stockSlide td {
  font-size: 0.8em;
}
</style>

